import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Spinner from "../Spinner";
import { SendPostRequest } from "../../http";
import Select from 'react-select';

function RegMembers() {
  const [memberData, setMemberData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'ascending' });
  const patientLogin = useSelector((state) => state.patient.patientLogin);

  // Sort options for React Select
  const sortOptions = [
    { value: 'register_date_asc', label: 'Date (Oldest First)' },
    { value: 'register_date_desc', label: 'Date (Newest First)' },
    { value: 'name_asc', label: 'Name (A-Z)' },
    { value: 'name_desc', label: 'Name (Z-A)' },
    { value: 'mrn_asc', label: 'MRN (Ascending)' },
    { value: 'mrn_desc', label: 'MRN (Descending)' },
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchData();
  }, []);

  useEffect(() => {
    // Apply search filter whenever searchTerm changes
    let results = memberData;
    
    if (searchTerm) {
      results = memberData.filter(item => 
        (item.name && item.name.toLowerCase().includes(searchTerm.toLowerCase())) ||
        (item.mrn && item.mrn.toLowerCase().includes(searchTerm.toLowerCase()))
      );
    }
    
    // Apply sorting
    if (sortConfig.key) {
      results = sortData(results, sortConfig.key, sortConfig.direction);
    }
    
    setFilteredData(results);
  }, [searchTerm, memberData, sortConfig]);

const fetchData = async () => {
  setIsLoading(true);
  try {
    const res = await SendPostRequest("healthcare/register-members", {
      contact_no: patientLogin?.contact_num,
    });

    if (res?.data && Array.isArray(res.data)) {
      setMemberData(res.data);
      setFilteredData(res.data);
    } else {
      setMemberData([]);
      setFilteredData([]);
    }
  } catch (error) {
    console.error("Error fetching members:", error);
    // Error case me empty state rakho
    setMemberData([]);
    setFilteredData([]);
  } finally {
    setIsLoading(false);
  }
};


  const sortData = (data, key, direction) => {
    return [...data].sort((a, b) => {
      // Handle empty values by placing them at the end
      if (!a[key] && !b[key]) return 0;
      if (!a[key]) return 1;
      if (!b[key]) return -1;
      
      let valueA = a[key];
      let valueB = b[key];
      
      // Special handling for date comparison
      if (key === 'register_date') {
        valueA = new Date(valueA);
        valueB = new Date(valueB);
      } else {
        // For string comparison, convert to lowercase
        valueA = valueA.toString().toLowerCase();
        valueB = valueB.toString().toLowerCase();
      }
      
      if (valueA < valueB) {
        return direction === 'ascending' ? -1 : 1;
      }
      if (valueA > valueB) {
        return direction === 'ascending' ? 1 : -1;
      }
      return 0;
    });
  };

  const handleSortChange = (selectedOption) => {
    if (!selectedOption) {
      setSortConfig({ key: null, direction: 'ascending' });
      return;
    }
    
    const [key, direction] = selectedOption.value.split('_');
    setSortConfig({ 
      key: key === 'register' ? 'register_date' : key, 
      direction: direction === 'asc' ? 'ascending' : 'descending' 
    });
  };

  const getSortIndicator = (key) => {
    if (sortConfig.key !== key) return null;
    return sortConfig.direction === 'ascending' ? '↑' : '↓';
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      border: '1px solid #ced4da',
      borderRadius: '0.25rem',
      minHeight: '45px',
      fontSize: '0.875rem'
    }),
    menu: (provided) => ({
      ...provided,
      fontSize: '0.875rem'
    })
  };

  return (
    <div className="Prescripition">
     

      {/* Search and Filter Controls */}
      <div className="row mb-3">
        <div className="col-md-4">
           <h3>Registered Members</h3>
        </div>
        <div className="col-md-4">
          <div className="input-group">
            <input
              type="text"
              className="form-control"
              style={{height:"45px"}}
              placeholder="Search by name or MRN..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            {searchTerm && (
              <button
                className="btn btn-outline-secondary"
                type="button"
                onClick={() => setSearchTerm("")}
              >
                Clear
              </button>
            )}
          </div>
        </div>
        <div className="col-md-4">
          <Select
            options={sortOptions}
            placeholder="Sort by..."
            isClearable
            styles={customStyles}
            onChange={handleSortChange}
            
          />
        </div>
        {/* <div className="col-md-3 d-flex align-items-center">
          <small className="text-muted">
            {filteredData.length} of {memberData.length} members shown
          </small>
        </div> */}
      </div>

      {isLoading ? (
        <div
          style={{ marginBottom: "60px" }}
          className="d-flex align-items-center justify-content-center "
        >
          <Spinner />
        </div>
      ) : (
        <div className="table-responsive">
          <table className="table mt-2">
            <thead className="thead-light">
              <tr>
                <th scope="col">
                  Register Date {getSortIndicator('register_date')}
                </th>
                <th scope="col">
                  MRN {getSortIndicator('mrn')}
                </th>
                <th scope="col">
                  Name {getSortIndicator('name')}
                </th>
                <th scope="col">Category</th>
              </tr>
            </thead>

            <tbody>
              {filteredData.length === 0 ? (
                <tr>
                  <td colSpan="4">
                    <div className="prescription-rapper">
                      {searchTerm ? "No matching records found" : "No Record Available"}
                    </div>
                  </td>
                </tr>
              ) : (
                filteredData.map((item, index) => (
                  <tr key={item?.id}>
                    <td>{item?.register_date || "--"}</td>
                    <td>{item?.mrn || "--"}</td>
                    <td>{item?.name || "--"}</td>
                    <td>{item?.category || "--"}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default RegMembers;